import { DistanceFilter, SearchFilter } from '@unmapped/core/filters';
import { useStore } from '@unmapped/core/hooks';
import { locationNameAlphaSort } from '@unmapped/core/state';
import { useEffect, useMemo, useRef } from 'react';
import { adapterMap } from './definitions/shared';
import { action } from 'mobx';
import React from 'react';
import { CemeteryOperator } from './definitions/Cemetery/types';
import FlagFilter from '@unmapped/core/filters/FlagFilter';
import { SchoolGrade, SchoolGrantEligibility, SchoolOperator } from './definitions/School/types';
export const useFilterSet = dataset => {
  const filters = useMemo(() => [new DistanceFilter('distance', {
    initialRadius: 25,
    initialUnit: 'mi'
  }), new SearchFilter('search'), new FlagFilter('operator', {
    options: dataset === 'school' ? SchoolOperator : CemeteryOperator,
    visible: dataset === 'school' || dataset === 'cemetery',
    disabled: dataset !== 'school' && dataset !== 'cemetery',
    initialState: dataset === 'cemetery' ? ['diocese'] : ['diocese', 'other']
  }), new FlagFilter('grades', {
    options: SchoolGrade,
    mode: 'all',
    visible: dataset === 'school',
    disabled: dataset !== 'school'
  }), new FlagFilter('grantEligibility', {
    options: SchoolGrantEligibility,
    visible: dataset === 'school',
    disabled: dataset !== 'school',
    initialState: ['eligible', 'ineligible']
  })], []);
  const initialRenderRef = useRef(true);
  useEffect(() => {
    if (initialRenderRef.current) {
      // don't update on first render because filters are already initialized with correct values
      initialRenderRef.current = false;
      return;
    }
    action('useFilterSet.kindUpdate', () => {
      const operatorFilter = filters[2];
      operatorFilter.options = dataset === 'school' ? SchoolOperator : CemeteryOperator, operatorFilter.visible = dataset === 'school' || dataset === 'cemetery';
    })();
  }, [dataset]);
  return filters;
};
export const useDataSource = (dataset, store) => {
  const initialRenderRef = useRef(true);
  useEffect(() => {
    if (initialRenderRef.current) {
      // don't update on first render because filters are already initialized with correct values
      initialRenderRef.current = false;
      return;
    }
    if (store.adapter !== adapterMap[dataset]) {
      action('useFilterSet.kindUpdate', () => {
        store.adapter = adapterMap[dataset];
      })();
    }
  }, [dataset]);
};
export const useSortManager = () => {
  const store = useStore();
  useEffect(action('useSortManager', () => {
    if (store.filterMap.search.state) {
      if (store.sort.label !== 'Relevance') {
        store.updateSort({
          label: 'Relevance',
          comparator: SearchFilter.createComparator('search'),
          direction: 'desc'
        });
      }
    } else if (store.filterMap.distance.state) {
      if (store.sort.label !== 'Distance') {
        store.updateSort({
          label: 'Distance',
          comparator: DistanceFilter.createComparator('distance'),
          direction: 'asc'
        });
      }
    } else if (store.sort.label !== 'Name') {
      store.updateSort({
        label: 'Name',
        comparator: locationNameAlphaSort,
        direction: 'desc'
      });
    }
  }), [store.filterMap.search.state, store.filterMap.distance.state]);
};
export const FocusedLocationContext = /*#__PURE__*/React.createContext({
  focusedLocation: null,
  setFocusedLocation: () => {}
});